"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrevArrow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var PrevArrow = function (props) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({}, props, { children: (0, jsx_runtime_1.jsxs)("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("g", { clipPath: "url(#clip0_1_7)", children: (0, jsx_runtime_1.jsx)("path", { d: "M5.70706 12.1879L16.9254 23.4656L18.2915 22.0996L8.66261 12.4707L8.37977 12.1879L8.66261 11.9051L18.2915 2.27622L16.9254 0.910183L5.70706 12.1879Z", fill: "white", stroke: "currentColor", strokeWidth: "0.8" }) }), (0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsx)("clipPath", { id: "clip0_1_7", children: (0, jsx_runtime_1.jsx)("rect", { width: "24", height: "24", fill: "white", transform: "matrix(-1 0 0 1 24 0.34375)" }) }) })] }) })));
};
exports.PrevArrow = PrevArrow;
